module.exports = __webpack_public_path__ + "img/derp.0f6b15af.png";